var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, computed, action } from "mobx";
import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
import { defaultItemForSportMode, itemIDs, AllOutrightsTabId } from "../../modes";
import { DeviceDetect } from "sb-resp-utils";
export class State {
    constructor(messageSender, blockId, domId, itemType = defaultItemForSportMode.firstSport, isAllOutrightsFirst = false) {
        this.onResize = () => {
            this.mobileScroll.value = this.getMobileScroll();
            this.mobileScroll.isResize = true;
        };
        this.messageSender = messageSender;
        this.selectedItemId = observable.box("");
        this.isEventView = false;
        this.items = observable([]);
        this.carouselTranslate = observable.box(0);
        this.blockId = blockId;
        this.internalMessageBus = internalMessageBus;
        this.defaultItemType = itemType;
        this.isActive = false;
        this.domId = domId;
        this.deviceDetect = DeviceDetect.getInstance();
        this.isAllOutrightsFirst = isAllOutrightsFirst;
        this.mobileScroll = {
            value: 0,
            isInitiate: false,
            isResize: false
        };
    }
    activate() {
        this.isActive = true;
        this.subscribeToToggleEventView(this.blockId, InternalMessageBusChannels.legacy.eventCard.changedToSide);
        this.setInitialFocus();
        window.addEventListener("resize", this.onResize);
    }
    deactivate() {
        this.isActive = false;
        this.unsubscribeToToggleEventView(this.blockId, InternalMessageBusChannels.legacy.eventCard.changedToSide);
        this.isEventView = false;
        this.carouselTranslate.set(0);
        window.removeEventListener("resize", this.onResize);
    }
    getMobileScroll() {
        const b = document.getElementById(this.domId);
        const el = b ? b.getElementsByClassName("rj-carousel-item--active")[0] : undefined;
        const scroll = b && el ? this.calculateMobileScroll(b, el) : 0;
        return scroll;
    }
    get SelectedItemId() {
        return this.selectedItemId.get();
    }
    get CarouselTranslate() {
        return this.carouselTranslate.get();
    }
    get Items() {
        return this.items;
    }
    add(item) {
        this.addToList(item, this.Items);
    }
    addToList(item, items) {
        const indexToInsert = items.findIndex(x => x.order > item.order);
        if (indexToInsert === -1) {
            items.push(item);
        }
        else {
            items.splice(indexToInsert, 0, item);
        }
    }
    remove(id, canUpdateSelectedItem = false) {
        const selectedItemId = this.selectedItemId.get();
        if (!canUpdateSelectedItem && id === selectedItemId) {
            return;
        }
        const itemToRemove = this.getItemById(id);
        if (itemToRemove) {
            this.items.remove(itemToRemove);
            if (this.items.length > 0 && id === selectedItemId) {
                this.selectItem(this.items[0]);
            }
        }
    }
    update(id, newValue, canUpdateSelectedItem = false) {
        if (canUpdateSelectedItem || this.selectedItemId.get() !== id) {
            this.updateItem(id, newValue);
        }
    }
    updateItem(id, newValue) {
        const item = this.getItemById(id);
        item && item.update(newValue);
    }
    getItemById(id) {
        return this.items.find(x => x.id === id);
    }
    getSelectedItem() {
        return this.getItemById(this.isAllOutrightsFirst ? AllOutrightsTabId : this.selectedItemId.get());
    }
    replaceItems(newItems, canUpdateSelectedItem = false) {
        const selectedItemId = this.selectedItemId.get();
        if (!canUpdateSelectedItem && newItems.length > 0 && newItems.find((item) => item.id === selectedItemId)) {
            newItems = this.getNewItemsWithoutChangingSelected(newItems, selectedItemId);
        }
        this.items.replace(newItems.sort((a, b) => a.order - b.order));
        this.resetSelectedItemId();
    }
    resetSelectedItemId() {
        const selectedItemId = this.selectedItemId.get();
        if (selectedItemId === "streaming") {
            return;
        }
        if (this.items.length > 0 && selectedItemId && !this.getItemById(selectedItemId)) {
            this.selectItem(this.items[0]);
        }
    }
    selectInitial() {
        const item = this.getInitialItem();
        if (item) {
            this.selectedItemId.set("");
            item && this.selectItem(item);
        }
        else {
            this.messageSender.SendMessage({
                type: "sports",
                id: "-1",
                order: 0
            });
        }
    }
    getInitialItem() {
        return this.getSelectedItem() || this.getItemBySportType(this.defaultItemType);
    }
    getItemBySportType(itemType) {
        let item = undefined;
        switch (itemType) {
            case defaultItemForSportMode.favorites:
                item = this.getItemById(itemIDs.favorites);
                break;
            case defaultItemForSportMode.liveStreaming:
                item = this.getItemById(itemIDs.liveStreaming);
                break;
            case defaultItemForSportMode.firstMarket:
                item = this.getItemWithMinOrder();
                break;
        }
        if (!item) {
            item = this.getFirstSportItem();
        }
        return item;
    }
    getFirstSportItem() {
        for (let item of this.items) {
            if (item.order >= 0) {
                return item;
            }
        }
        return undefined;
    }
    getNewItemsWithoutChangingSelected(newItems, selectedItemId) {
        const selectedItem = this.getSelectedItem();
        if (selectedItem) {
            newItems = newItems.filter(x => selectedItemId !== x.id);
            this.addToList(selectedItem, newItems);
        }
        return newItems;
    }
    selectItem(item) {
        if (this.selectedItemId.get() === item.id) {
            return;
        }
        this.messageSender.SendMessage(item);
        this.selectedItemId.set(item.id);
    }
    selectItemById(itemId) {
        if (this.isActive) {
            const item = this.getItemById(itemId);
            item && this.selectItem(item);
        }
        else {
            this.selectedItemId.set(itemId);
        }
    }
    setInitialFocus() {
        if (this.deviceDetect.isDesktop) {
            this.setTransition();
        }
        else {
            this.mobileScroll.value = this.getMobileScroll();
            this.mobileScroll.isInitiate = true;
        }
    }
    setTransition() {
        const b = document.getElementById(this.domId);
        const el = b ? b.getElementsByClassName("rj-carousel-item--active")[0] : undefined;
        const translate = b && el ? this.calculateTranslate(b, el) : 0;
        this.carouselTranslate.set(translate);
    }
    calculateMobileScroll(block, el) {
        const elPosition = el.offsetLeft;
        const blockWidth = block.getBoundingClientRect().width;
        if (elPosition <= blockWidth) {
            if (el.offsetLeft + el.offsetWidth > blockWidth) {
                return elPosition;
            }
            return 0;
        }
        return elPosition;
    }
    calculateTranslate(b, el) {
        const elPosition = el.getBoundingClientRect().left - b.getBoundingClientRect().left + el.getBoundingClientRect().width;
        const blockWidth = b.getBoundingClientRect().width;
        if (elPosition < blockWidth) {
            return 0;
        }
        return (elPosition - blockWidth) * -1;
    }
    clear() {
        this.items.replace([]);
    }
    subscribeToToggleEventView(BlockUniqueID, channel) {
        this.internalMessageBus.on(`${BlockUniqueID}.${channel}`, this.toggleEventView, this);
    }
    unsubscribeToToggleEventView(BlockUniqueID, channel) {
        this.internalMessageBus.off(`${BlockUniqueID}.${channel}`, this.toggleEventView, this);
    }
    toggleEventView(topic) {
        topic.data && topic.data[0] && (this.isEventView = topic.data[0].changedToSide);
    }
    getItemWithMinOrder() {
        return this.items.reduce((prev, curr) => {
            return prev.order <= curr.order ? prev : curr;
        });
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], State.prototype, "isEventView", void 0);
__decorate([
    observable,
    __metadata("design:type", DeviceDetect)
], State.prototype, "deviceDetect", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], State.prototype, "mobileScroll", void 0);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], State.prototype, "SelectedItemId", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], State.prototype, "CarouselTranslate", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], State.prototype, "setInitialFocus", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], State.prototype, "toggleEventView", null);
//# sourceMappingURL=State.js.map